// extracted by mini-css-extract-plugin
module.exports = {"try":"try_try__85U9G","title":"try_title__int3f","recommends":"try_recommends__5H1h_","recommend":"try_recommend__uuL4D","active":"try_active__1jo6s"};